import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import React from "react"
import type { LandingPageFootnotes } from "types"
import { createMarkup } from "utils/createMarkup"

import { container } from "./Footnotes.css"

type Props = CMSPageProps & LandingPageFootnotes

export const Footnotes: React.FC<Props> = ({ title, content }) => (
  <div className={container} id="footnotes" data-testid={title}>
    <div dangerouslySetInnerHTML={createMarkup(content ?? "Footnotes")} />
  </div>
)
